import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneNumberUSA' })
export class PhoneNumberUSAPipe implements PipeTransform {

    transform(value: string) {
        if (value) {
            return this.parseNumber(value);
        }
        return undefined;
    }

    parseNumber(value: string): string {
        if (value.length != 10) {
            return value;
        }

        var areaCode = value.substring(0, 3);
        var firstThree = value.substring(3, 6);
        var lastFour = value.substring(6, 10);
        return areaCode + '-' + firstThree + '-' + lastFour;
    }
}
